<template>
	<div class="fluid card" v-if="accessory.public || selected">
		<div class="content">
			<div class="header">
				{{ accessory.name }}
				<div class="ui sub header" v-if="showPrice">
          {{ accessory.pricing[0].price }} {{ accessory.pricing[0].currency }}
          <span v-if="waterMeter"> / m<sup>3</sup></span>
        </div>
			</div>
			<div class="meta" v-if="accessory.mandatory"><i class="info blue circle icon"/> {{ $t('components.accessory.mandatory') }}</div>
		</div>
		<div class="content">
			<div class="description">
				<h4 class="header">{{ accessory.intro }}</h4>
				{{ accessory.description }}
			</div>
		</div>
    <div class="content" v-show="changeable && deletable && accessory.apply_storage_count && accessory.storage_count_current <= 0">
      <div class="storage-count">
        <span>{{ $t('globals.accessories.no_accessory_left') }}</span>
      </div>
    </div>
		<template v-if="isChangeable()">
			<button class="ui bottom attached green button" v-if="selected" @click="selectAccessory()">
        <i class="checkmark icon"/>{{ $t('components.accessory.added') }}
      </button>
			<button class="ui bottom attached button" v-else @click="selectAccessory()" :disabled="deletable && accessory.apply_storage_count && accessory.storage_count_current <= 0 ? 'disabled' : false">
        <i class="plus icon"/>{{ $t('components.accessory.select') }}
      </button>
		</template>
		<template v-else>
			<div class="ui bottom attached green disabled button"><i class="checkmark icon"/>{{ $t('components.accessory.added') }}</div>
		</template>
	</div>
</template>

<script>
export default {
	name: 'Accessory',

	props: [ 'accessory', 'product', 'changeable', 'deletable', 'addedAccessories', 'waterMeter' ],

	data () {
		return {
			showPrice: false,
			selected: false
		}
	},

	watch: {
		selected (selected) {
			if (selected) {
				this.$emit('selected', this.accessory.id)
			} else {
				this.$emit('deselected', this.accessory.id)
			}
		},

		accessory () {
			this.findPrice()

			if (this.addedAccessories) {
				this.findAddedAccessories()
			}
		},

		addedAccessories (addedAccessory) {
			if (addedAccessory) {
				this.findAddedAccessories()
			}
		}
	},

	methods: {
		findPrice () {
			this.showPrice = this.accessory.pricing.length === 1
		},

		selectAccessory () {
			this.selected = !this.selected
		},

		isChangeable () {
			if (this.accessory.mandatory) {
				return false
			} else return !!this.changeable
		},

		findAddedAccessories () {
			const _this = this

			$.map(this.addedAccessories, function (amount, accessoryId) {
				if (_this.accessory.id === parseInt(accessoryId)) {
					_this.selected = true
				}
			})
		}
	},

	mounted () {
		this.findPrice()

		if (this.addedAccessories) {
			this.findAddedAccessories()
		}
	}
}
</script>

<style scoped>
  .storage-count {
    background-color: #db2828;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/Accessory.vue